import script from "./Summary.vue?vue&type=script&setup=true&lang=js"
export * from "./Summary.vue?vue&type=script&setup=true&lang=js"

import "./Summary.vue?vue&type=style&index=0&id=a89680c8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a89680c8"]])

export default __exports__